import { createSelector } from 'reselect';
import { atbCarouselsPDPSelector } from 'selectors/testTarget/offers/atbCarouselsPDP/atbCarouselsPDPSelector';

const showSelector = createSelector(atbCarouselsPDPSelector, atbCarouselsPDP => !!atbCarouselsPDP.show);

export { showSelector };
